import { MaybeNil } from './interfaces';
import { ZodError, ZodType, ZodTypeDef } from 'zod';

export const zodFieldErrors = <T>(
  zodErrors: MaybeNil<ZodError<T>>,
  field: T extends any ? keyof T : never,
): string | undefined => {
  return zodErrors?.formErrors.fieldErrors[field]?.join('. ');
};

export const zodFormErrors = <T>(
  zodErrors: MaybeNil<ZodError<T>>,
): string | undefined => {
  return zodErrors?.formErrors.formErrors.join('. ');
};

export const isZodFieldErrors = <T>(
  zodErrors: MaybeNil<ZodError<T>>,
  field: T extends any ? keyof T : never,
): boolean => {
  return Boolean(zodFieldErrors(zodErrors, field));
};

// a helper type which allows to constrain zod validator to specific typescript type
export type ZodProperties<T> = Required<{
  [K in keyof T]: ZodType<T[K], ZodTypeDef, T[K]>;
}>;
